import { createClient } from '@supabase/supabase-js';

const supabaseURL = 'https://jqhvravrrxhvuqsjatkj.supabase.co';
const supabaseKey = process.env.REACT_APP_PUBLIC_SUPABASE_KEY;

export const supabase = createClient(supabaseURL, supabaseKey);
